/**
 * @generated SignedSource<<26fde1e4c3372d5a39e790252f764c9b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TodoStatus = "DONE" | "PENDING";
import { FragmentRefs } from "relay-runtime";
export type TodoListItemMainContentText_todo$data = {
  readonly isIssue: boolean;
  readonly status: TodoStatus;
  readonly title: string;
  readonly " $fragmentType": "TodoListItemMainContentText_todo";
};
export type TodoListItemMainContentText_todo$key = {
  readonly " $data"?: TodoListItemMainContentText_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoListItemMainContentText_todo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoListItemMainContentText_todo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isIssue",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "type": "Todo",
  "abstractKey": null
};

(node as any).hash = "c5d2ed12eab2cf8fbe17efba8a4f7837";

export default node;
